import { render, staticRenderFns } from "./UtenteHeadquarters.vue?vue&type=template&id=35bdb962&"
import script from "./UtenteHeadquarters.vue?vue&type=script&lang=ts&"
export * from "./UtenteHeadquarters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports